export const MODAL_NAME = 'Traffic Recommendation Modal';
